// extracted by mini-css-extract-plugin
export default {"profile-img":"r2THUOtZixtxv5Mx0FYh","body":"H_BxajzJ7U11fwYQVOyF","copy":"fiCNyGhssEHN12G7cwCR"};